export const HIDE_UI_TIME = 3000
import { AUDIO_PLAY, AUDIO_MAIN, playAudio } from 'aria-viewer/audiomanager/audioManagerActions'
import { Map } from 'immutable'

const initializeAudio = ({ dispatch, getState }) => {
    // TODO: if supplemental media, audioType becomes
    // TODO  "AUDIO_SUPP"
    // TODO  audioManager needs to be redone
    // TODO  so data/state isn't so crazy
    if (
        getState().getIn(['audioManager', 'state', AUDIO_MAIN]) != AUDIO_PLAY &&
        false /*&& (autoplay !== false
            TODO: this seemed to always get false?*/
    ) {
        dispatch(playAudio(AUDIO_MAIN))
    }
}

/*=============================================
 =              Action Constants              =
 =============================================*/

export const SET_QUALITY_LIST = 'SET_QUALITY_LIST'
export const SET_CURRENT_QUALITY = '|A|SET_CURRENT_QUALITY'
export const SET_VIDEO_VOLUME = '|A|Video.SET_VIDEO_VOLUME'
export const MUTE_VIDEO_VOLUME = 'Video.MUTE_VIDEO_VOLUME'
export const UNMUTE_VIDEO_VOLUME = 'Video.UNMUTE_VIDEO_VOLUME'
export const TOGGLE_VIDEO_VOLUME_MUTED = 'Video.TOGGLE_VIDEO_VOLUME_MUTED'

export const SET_START_TIME = 'Video.SET_START_TIME'

export const REGISTER_VIDEO_PLAYER = 'Video.REGISTER_VIDEO_PLAYER'
export const DESTROY_VIDEO_PLAYER = 'Video.DESTROY_VIDEO'

export const ENABLE_ACCELEROMETER_CONTROLS = 'Video.ENABLE_ACCELEROMETER_CONTROLS'

export const PLAY_VIDEO_REQUEST = 'Video.PLAY_VIDEO_REQUEST'
export const PAUSE_VIDEO_REQUEST = 'Video.PAUSE_VIDEO_REQUEST'
export const STOP_VIDEO_REQUEST = 'Video.STOP_VIDEO_REQUEST'

export const PLAY_VIDEO = '|A|Video.PLAY_VIDEO'
export const PAUSE_VIDEO = 'Video.PAUSE_VIDEO'
export const STOP_VIDEO = 'Video.STOP_VIDEO'

export const HIDE_VIDEO_UI = 'Video.HIDE_VIDEO_UI'
export const SHOW_VIDEO_UI = 'Video.SHOW_VIDEO_UI'

export const VIDEO_DRAG_END = '|A|Video.DRAG_END'
export const SEEKED = '|A|Video.SEEKED'

export const RESOLVE_VIMEO_URL = 'Video.RESOLVE_VIMEO_URL'

export const DRAGGING_HINT_MOUNTED = 'Video.DRAGGING_HINT_MOUNTED'
export const SET_DRAG_HINT_DETAILS = 'Video.SET_DRAG_HINT_DETAILS'

export const SET_VIDEO_PROGRESS = 'Video.SET_VIDEO_PROGRESS'
export const SET_VIDEO_PLAYER = 'Video.SET_VIDEO_PLAYER'
export const TOGGLE_VIDEO_VOLUME_BAR_VISIBILITY = 'Video.TOGGLE_VIDEO_VOLUME_BAR_VISIBILITY'

/*=============================================
 =     Show/Hide Video Actions & Timing       =
 =============================================*/
// TODO -> make UI show/hide Dispatcher code more DRY
// TODO    to ensure consistency/simplicity

let timedHideUIDispatcher = undefined,
    timedShowUIDispatcher = undefined,
    hideUITimeoutAssigned = undefined,
    showUITimeoutAssigned = undefined

export const registerVideoPlayer = player => ({
    type: REGISTER_VIDEO_PLAYER,
    player,
})

export const enableAccelerometerControls = enabled => (dispatch, getState) => {
    const videoPlayer = getState().getIn(['video', 'videoPlayer'])

    videoPlayer && videoPlayer.enableAccelerometerControls(enabled)

    dispatch({
        type: ENABLE_ACCELEROMETER_CONTROLS,
        enabled,
    })
}

export const hideVideoUI = () => {
    return (dispatch, getState) => {
        if (timedShowUIDispatcher) {
            clearTimeout(showUITimeoutAssigned)
            timedHideUIDispatcher = undefined
        }

        if (timedHideUIDispatcher) {
            clearTimeout(hideUITimeoutAssigned)
            timedHideUIDispatcher = undefined
        }

        const video = getState().get('video')

        if (video.get('isVideoUIVisible') === false) {
            return
        } else dispatch({ type: HIDE_VIDEO_UI })
    }
}

const resetBindedHideUITimer = function(dispatchAction, getHideCondition, time, setFromShowTimer) {
    // reset and reassign timer
    if (timedHideUIDispatcher) {
        clearTimeout(hideUITimeoutAssigned)
        timedHideUIDispatcher = undefined
    }

    if (!setFromShowTimer) {
        if (timedShowUIDispatcher) {
            clearTimeout(showUITimeoutAssigned)
            timedShowUIDispatcher = undefined
        }
    }

    timedHideUIDispatcher = function() {
        if (!getHideCondition || (getHideCondition && getHideCondition())) {
            dispatchAction({ type: HIDE_VIDEO_UI })
        }
    }

    if (time) {
        hideUITimeoutAssigned = setTimeout(timedHideUIDispatcher, time)
    } else {
        timedHideUIDispatcher()
    }
}

const resetBindedShowUITimer = function(dispatchAction, getCancelCondition, time) {
    //reset and reassign
    if (timedShowUIDispatcher) {
        clearTimeout(showUITimeoutAssigned)
        timedShowUIDispatcher = undefined
    }

    timedShowUIDispatcher = function() {
        if (!getCancelCondition || (getCancelCondition && !getCancelCondition())) {
            dispatchAction({ type: SHOW_VIDEO_UI })
        }
    }

    if (time) {
        showUITimeoutAssigned = setTimeout(timedShowUIDispatcher, time)
    } else {
        timedShowUIDispatcher()
    }
}

/**
 *
 * @param p
 * @param p.timeShown amount of time shown
 * @param p.delay delay before showing ui
 * @param p.getCancelCondition a callback to check whether a condition
 *              which would cancel the start callback is shown
 * @returns {function(*=, *)}
 */

export const showSimpleVideoUI = (p, isVideoUIVIsible) => {
    let timeShown =
            {
                undefined: undefined,
                number: p,
                object: p && p.timeShown ? p.timeShown : undefined,
            }[typeof p] || undefined,
        delay =
            {
                undefined: undefined,
                number: undefined,
                object: p && p.delay ? p.delay : undefined,
            }[typeof p] || undefined

    if (timeShown && delay && timeShown < delay) {
        throw new Error('time shown cannot be larger than ' + 'the delay for a showVideoUI action')
    }

    return isVideoUIVisible => {
        if (!delay) {
            if (isVideoUIVisible == false) {
                return { type: SHOW_VIDEO_UI }
            }
        } //if delay, add relevant timeouts
        else {
            timedShowUIDispatcher = setTimeout(() => {
                if ((p.getCancelCondition && !p.getCancelCondition()) || !p.getCancelCondition) {
                    if (isVideoUIVisible == false) {
                        return { type: SHOW_VIDEO_UI }
                    }
                }
            }, delay)
        }

        if (timeShown) {
            resetBindedHideUITimer(dispatch, null, timeShown, true)
        } else {
            if (timedHideUIDispatcher) {
                clearTimeout(hideUITimeoutAssigned)
                timedHideUIDispatcher = undefined
            }
        }
    }
}

export const hideSimpleVideoUI = isVideoUIVisible => {
    return (dispatch, getState) => {
        if (timedShowUIDispatcher) {
            clearTimeout(showUITimeoutAssigned)
            timedHideUIDispatcher = undefined
        }

        if (timedHideUIDispatcher) {
            clearTimeout(hideUITimeoutAssigned)
            timedHideUIDispatcher = undefined
        }

        const video = getState().get('video')

        if (isVideoUIVisible === false) {
            return
        } else {
            return { type: HIDE_VIDEO_UI }
        }
    }
}

/**
 *
 * @param p
 * @param p.timeShown amount of time shown
 * @param p.delay delay before showing ui
 * @param p.getCancelCondition a callback to check whether a condition
 *              which would cancel the start callback is shown
 * @returns {function(*=, *)}
 */
export const showVideoUI = p => {
    // first assign amount of time until close
    // after showing; by default if p is specified
    // as a number, it becomes the close timeout
    // (in ms), otherwise, p is a parameter
    // object and closeTimeout is its member
    let timeShown =
            {
                undefined: undefined,
                number: p,
                object: p && p.timeShown ? p.timeShown : undefined,
            }[typeof p] || undefined,
        // assign delay according to if p.delay is assigned
        // [this will control delay time until shown]
        delay =
            {
                undefined: undefined,
                number: undefined,
                object: p && p.delay ? p.delay : undefined,
            }[typeof p] || undefined

    if (timeShown && delay && timeShown < delay) {
        throw new Error('time shown cannot be larger than ' + 'the delay for a showVideoUI action')
    }

    return (dispatch, getState) => {
        const video = getState().get('video')
        if (!delay) {
            if (video.get('isVideoUIVisible') == false) {
                dispatch({ type: SHOW_VIDEO_UI })
            }
        } //if delay, add relevant timeouts
        else {
            timedShowUIDispatcher = setTimeout(() => {
                if ((p.getCancelCondition && !p.getCancelCondition()) || !p.getCancelCondition) {
                    if (video.get('isVideoUIVisible') == false) {
                        dispatch({ type: SHOW_VIDEO_UI })
                    }
                }
            }, delay)
        }

        if (timeShown) {
            resetBindedHideUITimer(dispatch, null, timeShown, true)
        } else {
            if (timedHideUIDispatcher) {
                clearTimeout(hideUITimeoutAssigned)
                timedHideUIDispatcher = undefined
            }
        }
    }
}

/**
 *
 * @param p
 * @param p.getHideCondition
 * @param p.time
 * @param p.bindedFromShowTimer
 * @returns {function(*=, *)}
 */
export let startHideVideoUITimer = function(p) {
    return (dispatch, getState) => {
        resetBindedHideUITimer(dispatch, p.getHideCondition, p.time, p.bindedFromShowTimer || false)
    }
}

export let cancelHideVideoUITimer = () => (dispatch, getState) => {
    clearTimeout(hideUITimeoutAssigned)
    timedHideUIDispatcher = undefined
}

/*=============================================
 =        Show/Hide VideoUI & Timing          =
 =============================================*/

export const setVideoQuality = (videoQualityOptions = []) => {
    return { type: SET_QUALITY_LIST, videoQualityOptions }
}

export const setCurrentQuality = videoQuality => ({ type: SET_CURRENT_QUALITY, videoQuality })

export const setVideoVolume = volume => ({ type: SET_VIDEO_VOLUME, volume })
export const muteVideoVolume = () => ({ type: MUTE_VIDEO_VOLUME })
export const unmuteVideoVolume = () => ({ type: UNMUTE_VIDEO_VOLUME })
export const toggleVideoVolumeMuted = () => ({ type: TOGGLE_VIDEO_VOLUME_MUTED })
export const setStartTime = second => ({ type: SET_START_TIME, second })
export const setVideoProgress = progress => ({ type: SET_VIDEO_PROGRESS, progress })
export const setVideoPlayer = player => ({ type: SET_VIDEO_PLAYER, player })
export const toggleVideoVolumeBarVisibility = () => ({ type: TOGGLE_VIDEO_VOLUME_BAR_VISIBILITY })

/*=============================================
 =    Video Play State Control/Requests    =
 =============================================*/

/**
 * TODO : figure out what kind of async params we'll
 * TODO : need
 * @returns {function(*, *)}
 */
export const playVideoRequest = (
    {
        /* params here */
    }
) => (dispatch, getState) => {
    // play our video via instance assigned if possible
    if (getState().getIn(['video', 'videoPlayer'])) {
        getState()
            .getIn(['video', 'videoPlayer'])
            .play()
        return { type: PLAY_VIDEO_REQUEST }
    }
}

export const playVideo = () => ({
    type: PLAY_VIDEO,
})

export const pauseVideoRequest = () => (dispatch, getState) => {
    // pause our video via instance assigned if possible
    if (getState().getIn(['video', 'videoPlayer'])) {
        getState()
            .getIn(['video', 'videoPlayer'])
            .pause()
        return { type: PAUSE_VIDEO_REQUEST }
    }
}

export const pauseVideo = () => ({
    type: PAUSE_VIDEO,
})

export const stopVideoRequest = () => {
    if (getState().getIn(['video', 'videoPlayer'])) {
        getState()
            .getIn(['video', 'videoPlayer'])
            .stop()
        return { type: STOP_VIDEO_REQUEST }
    }
}

export const stopVideo = () => ({
    type: STOP_VIDEO,
})

export const dragVideoEnd = () => ({
    type: VIDEO_DRAG_END,
})

export const seeked = () => ({
    type: SEEKED,
})

export const draggingHintMounted = () => ({
    type: DRAGGING_HINT_MOUNTED,
})

export const setDragHintDetails = draggingHint => ({
    type: SET_DRAG_HINT_DETAILS,
    draggingHint: Map(draggingHint),
})
